<div class="container">
  <h3 class="text-primary ab_left_text">TASK UTILITY MANAGER
  </h3>
  <blockquote class="generic-blockquote">
    Compliance Planet includes amongst it’s features a task manager from which various tasks can be <strong>created,
      assigned,
      monitored, escalated and controlled</strong>. It serves as a report workflow monitoring tool

  </blockquote>
</div>